import React from "react";

export default function BlueBannerNews() {
  return (
    <div className="w-full bg-[#1E74FD] py-4 px-6 text-center select-none shadow-md">
      <span className="text-white font-oswald text-sm sm:text-base md:text-lg font-bold tracking-widest uppercase">
        BAB MEDIA NEWS AND EXCLUSIVE CONTENT REMAIN EXCLUSIVE TO THEIR OWN DEDICATED TABS.
      </span>
    </div>
  );
}
